<template>
  <div>
    <div v-if="!$route.meta.quiet">
      <b-alert v-if="isAdmin" show variant="danger" class="mb-0">
        You are logged in as a different user. Please be careful, and log out
        when you are finished.
        <b-btn variant="link" @click="switchBack">Switch back</b-btn>
      </b-alert>

      <b-alert v-if="!user.verified" show variant="warning" class="mb-0">
        Please verify your email to keep your account active. Make sure to check
        your spam folder. Didn't get it?
        <b-btn variant="link" @click="resendEmail">Resend email</b-btn>
      </b-alert>

      <b-alert v-if="passwordDays < 14" show variant="danger" class="mb-0">
        Your password will expire in {{ passwordDays | pluralize("day") }}
        <router-link to="/account">Change now</router-link>
      </b-alert>

      <b-alert
        v-if="defaultCardStatus"
        show
        :variant="defaultCardStatus === 'has expired' ? 'danger' : 'warning'"
        class="mb-0"
      >
        Your card ending in {{ defaultCard.last4 }} {{ defaultCardStatus }}!
        <router-link to="/billing">Update now</router-link>
      </b-alert>
    </div>
    <!-- :disabled="isLoading" -->

    <AppBreadcrumbs v-if="user" />
  </div>
</template>

<script>
import moment from "moment";
import API from "@/api";

import AppBreadcrumbs from "./Breadcrumbs.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    AppBreadcrumbs
  },

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters(["isAdmin"]),

    defaultCard() {
      const methods = this.$store.state.billing.methods;
      return methods ? methods.current : null;
    },

    defaultCardStatus() {
      if (!this.defaultCard) return false;

      // date constructor month is 0-indexed, and card is valid until end of month
      // so using exp_month for date constructor gives expiration date
      const { exp_month, exp_year } = this.defaultCard;
      const expiry = new Date(exp_year, exp_month, 1);
      const today = Date.now();

      // check if expired
      if (expiry < today) {
        return "has expired";
      }

      // check if expiring within 1 month
      expiry.setMonth(expiry.getMonth() - 1);
      if (expiry < today) {
        return "is expiring soon";
      }

      return false;
    },

    passwordDays() {
      const org = this.user.organization;
      if (!org) return Infinity;

      const org90DayPasswords = org.settings.require_password_change;
      if (!org90DayPasswords) return Infinity;

      const lastPasswordTime = moment(this.user.last_password_time);
      const expiry = moment(lastPasswordTime).add(90, "days");
      return expiry.diff(moment(), "days");
    }
  },

  methods: {
    switchBack() {
      this.$store.dispatch("restoreSession");
    },

    async resendEmail() {
      if (this.isLoading) return;

      try {
        this.isLoading = true;
        await API.resend(this.user.email);
        this.$notify({
          type: "success",
          text: "Email sent"
        });
      } catch (err) {
        console.warn(err);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
